import LegalAcceptance from 'Core/components/TermsAndConditions/LegalAcceptance';
import React, {ReactNode} from 'react';
import {UserClaims} from 'Users/models/Claims';
import PortalFooterWrapper from '../Footer/PortalFooterWrapper';
import './TermsAndConditions.sass';

type TermsAndConditionsProps = {
  claims: UserClaims;
  children: ReactNode;
};

const TermsAndConditions = (props: TermsAndConditionsProps) => {
  const {claims, children} = props;
  const hasAcceptedTermsAndConditions = claims.unacceptedLegalDocuments.length === 0;
  return hasAcceptedTermsAndConditions ? <>{children}</>
  :<>
    <LegalAcceptance />
    <PortalFooterWrapper/>
  </>
  ;
};

export default TermsAndConditions;
